<template>
    <div>
      <button class="btn btn-success mx-2 " @click="btnClicked">جزییات سفارش</button>
    <!--  <div class="col">
        <router-link :to="'/production-management/supply/' + row.product.id" class="btn btn-success btn-block">جزییات سفارش</router-link>
      </div>-->
    </div>
</template>

<script>
    import * as $ from 'jquery';


    export default {
        name: 'inner-box-toggler',
        props: ['header', 'row'],
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {
            btnClicked() {
                this.$emit('toggleInnerBox');

            },
        }
    }
</script>

<style scoped>

</style>
